/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Pos_TopInputs */

const vi_shop_home_pos_top = /** @type {(inputs: Shop_Home_Pos_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trên`)
};

/**

* @param {Shop_Home_Pos_TopInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_pos_top = /** @type {((inputs?: Shop_Home_Pos_TopInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Pos_TopInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_pos_top(inputs)
});